import { render, staticRenderFns } from "./lastLocation.vue?vue&type=template&id=28e4e6bb&scoped=true&"
import script from "./lastLocation.vue?vue&type=script&lang=ts&"
export * from "./lastLocation.vue?vue&type=script&lang=ts&"
import style0 from "./lastLocation.vue?vue&type=style&index=0&id=28e4e6bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4e6bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28e4e6bb', component.options)
    } else {
      api.reload('28e4e6bb', component.options)
    }
    module.hot.accept("./lastLocation.vue?vue&type=template&id=28e4e6bb&scoped=true&", function () {
      api.rerender('28e4e6bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlDispositivos/lastLocation.vue"
export default component.exports